import React, { useEffect, useState,useRef, useCallback  } from 'react'
import { Breadcrumb, CardBasic, PaginationCustom, DateRangeP, SButton, TextInput, ModalForm, ConfirmModal } from '../../components'
import Select from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
import { Ceklis, Man, Young } from '../../assets';
import { API_BASE_URL } from '../../config';
import { useSelector } from 'react-redux';
import ShowAlert from '../../components/ShowAlert';


function Appointment() {
    const [selectedStatus, setSelectedStatus] = useState({label: 'All',value: 'All'});
    const [searchTerm, setSearchTerm] = useState('');
    const [dateRange, setDateRange] =  useState({
        startDate: new Date(),
        endDate: new Date(),
    });
    const [apiData, setApiData] = useState([]);
    const [newData, setNewData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [therapisOpt, setTherapisOpt] = useState([]);
    const [treatmentOpt, setTreatmentOpt] = useState([]);
    const [room, setRoom] = useState([]);

    const [showNotif, setShowNotif] = useState(false);
    const [notifType, setNotifType] = useState('success');
    const [notifMessage, setNotifMessage] = useState('Form has been successfully submitted!');

    const navigate = useNavigate();
    const location = useLocation();
    const user = useSelector((state) => state.auth);

    const arr = [
        {label: 'All',value: 'All'},
        {label: 'Confirmed',value: 'Confirmed'},
        {label: 'Pending',value: 'Pending'},
        {label: 'Canceled',value: 'Canceled'}
    ];

    function formatDate(date, withTime = false) {
        const d = typeof date === 'string' ? new Date(date) : date;
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        if (withTime) {
            return `${yyyy}-${mm}-${dd} 23:59:59`;
        }else{
            return `${yyyy}-${mm}-${dd}`;
        }
    }

    function formatTime(date){
        const d = typeof date === 'string' ? new Date(date) : date;
        const hh = String(d.getHours()).padStart(2, '0');
        const mm = String(d.getMinutes()).padStart(2, '0');
        return `${hh}:${mm}`;
    }

    const handleStatusChange = (selectedOption) => {
        setSelectedStatus(selectedOption);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleCreate = () => {
        navigate('create')
    };

    const normalizeDate = (date) => {
        const normalized = new Date(date);
        normalized.setHours(0, 0, 0, 0); // Set time to 00:00:00
        return normalized;
    };

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('access_token');
            const res = await fetch(
                `${API_BASE_URL}/auth/appointment/${user.user.klinik_id}`, 
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    }
                }
            );
            if (!res.ok) {
                const errorData = await res.json().catch(() => ({}));
                console.log(errorData.message || 'Gagal mengambil data!');
                return;
            }
            const data = await res.json();
            
            setApiData(data);
        } catch (error) {
            if (window.confirm('Gagal mengambil data. Coba lagi?')) {
                fetchData();
            }
        } finally {
            setIsLoading(false);
        }
    }, [user.user.klinik_id]);
    

    useEffect(() => {
        fetchData();
    },[fetchData]);


    useEffect(() => {
        // if (apiData.data.length > 0) {
            const filterByDateAndStatus = (data = []) => {
                const filteredData = data.filter((item) => {
                    const itemDate = normalizeDate(item.appointment_date); // Normalize item date
                    const startDate = normalizeDate(dateRange.startDate); // Normalize start date
                    const endDate = normalizeDate(dateRange.endDate); // Normalize end date
                   
                    const dateMatch = itemDate >= startDate && itemDate <= endDate;// Filter by date

                    const statusMatch = selectedStatus.value === 'All' || item.status === selectedStatus.value; // Filter by status
                    const searchMatch = searchTerm.trim() === "" || (item.full_name && item.full_name.toLowerCase().includes(searchTerm.toLowerCase()));
                    return dateMatch && statusMatch && searchMatch;
                });

                // const sortedData = filteredData.sort((a, b) => {
                //     const dateA = new Date(normalizeDate(a.date));
                //     const dateB = new Date(normalizeDate(b.date));
                //     return dateA - dateB; // Ascending order
                // });

                return filteredData;
            };
            
            const filteredAndSortedData  = filterByDateAndStatus(apiData.data);
            setNewData(filteredAndSortedData );
        // }
    }, [apiData, dateRange,selectedStatus,searchTerm]);

    useEffect(() => {
        const fetchTreatment = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/master_treatment_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );

                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data!');
                    return;
                }
                const treatment = await res.json();
                setTreatmentOpt(
                    Array.isArray(treatment.data)
                        ? treatment.data.map(item => ({
                            value: item.id || item.value,
                            label: item.treatment_name || item.label,
                        }))
                        : []
                );
            } catch (error) {
                console.error("Error fetching treatment:", error);
            }
        };

        const fetchTherapis = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/employee_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );

                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data!');
                    return;
                }
                const therapists = await res.json(); 
                
                const filterTherapis =  Array.isArray(therapists.data) ? 
                    therapists.data.filter((item) => item.role === 1 || item.role === 3).map(item => ({
                        value: item.id || item.value,
                        label: item.full_name || item.label,
                    })) : [];

                setTherapisOpt(
                   filterTherapis
                );
            } catch (error) {
                console.error("Error fetching therapis:", error);
            }
        };

        const fetchRooms = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/room_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );
                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data!');
                    return;
                }
                const rooms = await res.json();
            
                setRoom(
                    Array.isArray(rooms.data)
                        ? rooms.data.map(item => ({
                            value: item.id || item.value,
                            label: item.name_room || item.label,
                        }))
                        : []
                );
            } catch (error) {
                console.error("Error fetching room:", error);
            } 
        }
    
        fetchTherapis();
        fetchTreatment();
        fetchRooms();
    },[user.user.klinik_id]);

    const CardTitle = () => {
        const Added = () => {
            return (
                <>
                    <i className="ki-outline ki-plus fs-2"></i>Appointment
                </>
            )
        }

        return (
            <>
                <div className='card-title'>
                    <div className="d-flex align-items-center position-relative my-1">
                        <i className="ki-outline ki-magnifier fs-3 position-absolute ms-4"></i>
                        <TextInput type={'text'} 
                        clas={'form-control form-control-solid w-250px ps-12'}
                        placeholder={'Search Patient'}
                        value={searchTerm}
                        onChange={handleSearchChange}
                        />
                    </div>
                </div>
                <div className='card-toolbar flex-row-fluid justify-content-end gap-5'>
                    <DateRangeP
                        selectedDate={dateRange}
                        setSelectedDate={setDateRange}
                    />
                    <div className="w-150px">
                        <Select
                            className=""
                            options={arr}
                            placeholder="Status"
                            isSearchable={false}
                            value={selectedStatus}
                            onChange={handleStatusChange}
                        />
                    </div>
                
                    <div>
                        <SButton
                            className={"btn btn-light-primary"}
                            children={<Added/>}
                            action={handleCreate}
                        />
                    </div>
                </div>
            </>
        )
    }

    const ListBody = ({arr}) => {
        const [activeIndex, setActiveIndex] = useState(null);
        const [filteredData, setFilteredData] = useState([]);
        const [showModal, setShowModal] = useState(false);
        const [showModalRegist, setShowModalRegist] = useState(false);
        const [showRegistModal, setShowRegistModal] = useState(false);
        const [showConfirmModal, setShowConfirmModal] = useState(false);
        const [showCancelModal, setShowCancelModal] = useState(false);
        const [currentData, setCurrentData] = useState([]);
        const [selectedUser, setSelectedUser] = useState(null);

        const [fields, setFields] = useState([]);
       

        const dropdownRef = useRef([]);


        //Toogle Button
        const toggleAction = (index) => {
            setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
        };

        // Menutup dropdown jika klik di luar
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (
                    activeIndex !== null &&
                    dropdownRef.current[activeIndex] &&
                    !dropdownRef.current[activeIndex].contains(event.target)
                ) {
                    setActiveIndex(null);
                }
            };

            document.addEventListener("click", handleClickOutside);
            return () => {
                document.removeEventListener("click", handleClickOutside);
            };
        }, [activeIndex]);

        const handlePagination = useCallback((data) => {
            setFilteredData((prevData) => {
                // Hanya setState jika data berbeda
                if (JSON.stringify(prevData) !== JSON.stringify(data)) {
                    return data;
                }
                return prevData;
            });
        }, []);

        // const normalizeData = (data) => {
        //     // Jika data adalah array, gabungkan nilai value-nya menjadi string
        //     if (Array.isArray(data)) {
        //         return data.map(item => item.value).join(', ');
        //     }

        //     // Jika data adalah string, langsung kembalikan
        //     return data;
        // };

        const actions = () => {
            return (
                <>
                    <i className="ki-outline fs-2"></i>Actions
                </>
            )
        }

        const handleEditModal  = (item) => {
            const selectedTherapis = therapisOpt.find(opt => String(opt.value) === String(item.therapist)) || { value: item.therapist, label: `Unknown (${item.therapist})` };
            const selectedTreatment = treatmentOpt.find(opt => String(opt.value) === String(item.treatment)) || { value: item.treatment, label: `Unknown (${item.treatment})` };

            let datePart = '';
            let timePart = '';
            if (item.appointment_time) {
                const [date, time] = item.appointment_time.split(' ');
                datePart = date; // format: YYYY-MM-DD
                timePart = time ? time.slice(0,5) : ''; // format: HH:mm
            }
            
            setCurrentData({
                id: item.id,
                no_medical_record: item.no_medical_record,
                patient: item.full_name,
                appointment_date: datePart,
                appointment_time: timePart,
                full_name: item.full_name,
                therapis: selectedTherapis,
                treatment: selectedTreatment,
                status: item.status,
            });

            let status = [
                {
                    value: 'Confirmed',
                    label: 'Confirmed'
                },
                {
                    value: 'Pending',
                    label: 'Pending'
                },
                {
                    value: 'Canceled',
                    label: 'Canceled'
                }
            ]

            setFields(
                [
                    { type: 'hidden', name: 'id', label: '_ids',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'hidden', name: 'no_medical_record', label: 'Medical Record',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'text', name: 'full_name', label: 'Name Patient',classLabel: 'form-label' ,placeholder: 'Enter name', value: '', className: '',disable: true,required: false},
                    { type: 'date', name: 'appointment_date', label: 'Date', classLabel: 'form-label',value: '', className: '',disable: false,required: true},
                    { type: 'time', name: 'appointment_time', label: 'Time',classLabel: 'form-label', value: '', className: '',disable: false,required: true },
                    { type: 'select', name: 'therapis', label: 'Therapis', classLabel: 'form-label', options: therapisOpt, value: '', className: '',disable: false,required: true  },
                    { type: 'select', name: 'treatment', label: 'Treatment',classLabel: 'form-label' ,options: treatmentOpt, placeholder: '', value: '', className: '',disable: false,required: true  },
                    { type: 'select', name: 'status', label: 'Status',classLabel: 'form-label' ,options: status, placeholder: 'Select Status', value: '', className: '',disable: false,required: true  },
                ]
            )
            
            setShowModal(true); 
        }

        const handleCloseModal = () => {
            setShowModal(false);
        };
        const handleCloseModalRegist = () => {
            setShowModalRegist(false);
        };

        function combineDateTime(date, time) {
            if (!date || !time) return '';
            // Pastikan time hanya hh:mm
            const timePart = time.slice(0, 5);
            return `${date} ${timePart}`;
        }

        const handleSaveModal = async (updatedData,data) => {
                const updAppointment = {
                    id: updatedData?.id,
                    no_medical_record: updatedData?.no_medical_record,
                    full_name: updatedData?.full_name,
                    appointment_date: formatDateYMD(updatedData?.appointment_date),
                    appointment_time: combineDateTime(
                        formatDateYMD(updatedData?.appointment_date),
                        updatedData?.appointment_time
                    ),
                    therapist: Array.isArray(updatedData?.therapis) 
                        ? updatedData?.therapis.map(item => item.value || item) 
                        : updatedData?.therapis?.value || updatedData?.therapis || null, 
                    treatment: Array.isArray(updatedData?.treatment) 
                        ? updatedData?.treatment.map(item => item.value || item) 
                        : updatedData?.treatment?.value || updatedData?.treatment || null, 
                    status: updatedData?.status,
                    updated_by: user.user.id,
                };
                setLoadingSave(true);

                try {
                    const token = localStorage.getItem('access_token');
                    const res = await fetch(`${API_BASE_URL}/auth/appointment/${updatedData.id}`, {
                        method: 'PATCH',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        },
                        body: JSON.stringify(updAppointment)
                    });

                    if (!res.ok) {
                        const errorData = await res.json().catch(() => ({}));
                        setNotifType('danger');
                        setNotifMessage(errorData.message || 'Gagal membuat data!');
                        setShowNotif(true);
                        setLoadingSave(false);
                        return;
                    }

                    fetchData();
                } catch (error) {
                    setNotifType('danger');
                    setNotifMessage(error.message || 'Terjadi kesalahan koneksi!');
                    setShowNotif(true);
                } finally {
                    setShowModal(false);
                    setLoadingSave(false);
                    setShowNotif(true);
                }
        }

        // Fungsi untuk menangani penutupan modal notifikasi
        const handleCloseConfirm = () => {
            setShowNotif(false);

            // Navigasi setelah notifikasi ditutup
            const basePath = location.pathname.split('/')[1];
            navigate(`/${basePath}`);
        };

        const handleSubmitConfirm = async (updatedData,data) => {
           if (!updatedData || !data) {
                console.error("Missing data to update.");
                return;
            }
            setLoadingSave(true);

            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(`${API_BASE_URL}/auth/appointment/${data.id}`, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    },
                    body: JSON.stringify({
                        no_medical_record: data.no_medical_record,
                        status: 'Confirmed',
                    })
                });

                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    alert(errorData.message || 'Gagal update status!');
                    setLoadingSave(false);
                    return;
                }

                fetchData();
            } catch (error) {
                alert('Terjadi kesalahan koneksi!');
                setShowConfirmModal(false);
                setLoadingSave(false);
            } finally {
                setShowConfirmModal(false);
                setLoadingSave(false);
            }
        }

        const handleCancelConfirm = async (updatedData,data) => {
            if (!updatedData || !data) {
                console.error("Missing data to update.");
                return;
            }
            setLoadingSave(true);

            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(`${API_BASE_URL}/auth/appointment/${data.id}`, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    },
                    body: JSON.stringify({
                        no_medical_record: data.no_medical_record,
                        status: 'Canceled' 
                    })
                });

                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    alert(errorData.message || 'Gagal update status!');
                    setLoadingSave(false);
                    return;
                }

                fetchData();
            } catch (error) {
                setNotifType('danger');
                setNotifMessage('Gagal mengupdate data!');
                setShowNotif(true);
                setShowCancelModal(false);
                setLoadingSave(false);
            } finally {
                setShowCancelModal(false);
                setLoadingSave(false);
            }
        }

        const handleRegistConfirm = async (updatedData,data) => {
            const selectedTherapis = therapisOpt.find(opt => Number(opt.value) === Number(updatedData.therapist)) || { value: updatedData.therapist, label: `Unknown (${updatedData.therapist})` };
            const selectedTreatment = treatmentOpt.find(opt => Number(opt.value) === Number(updatedData.treatment)) || { value: updatedData.treatment, label: `Unknown (${updatedData.treatment})` };
            
            setCurrentData({
                id: updatedData.id,
                no_medical_record: updatedData.no_medical_record,
                full_name: updatedData.full_name,
                appointment_date: updatedData.appointment_date,
                appointment_time: updatedData.appointment_time,
                phone_number: updatedData.phone_number,
                notes: updatedData.notes,
                klinik_id: user.user.klinik_id,
                doctor_id: selectedTherapis,
                treatment: selectedTreatment
            });

            setFields(
                [
                    { type: 'hidden', name: 'id', label: '_ids',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'hidden', name: 'no_medical_record', label: 'Medical Record',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'select', name: 'doctor_id', label: 'Therapis', classLabel: 'form-label', options: therapisOpt, value: selectedTherapis, className: '',disable: false,required: true  },
                    { type: 'select', name: 'treatment', label: 'Treatment',classLabel: 'form-label' ,options: treatmentOpt, placeholder: '', value: selectedTreatment, className: '',disable: false,required: true  },
                    { type: 'select', name: 'room_id', label: 'Room',classLabel: 'form-label' ,options: room,placeholder: '', value: '', className: '',disable: false,required: true,  },
                ]
            )
            
            setShowRegistModal(false);
            setShowModalRegist(true); 
        }

        const getSelectValue = (field) => {
            // Jika array (hasil select baru), ambil value pertama
            if (Array.isArray(field)) {
                return field[0]?.value || '';
            }
            // Jika objek (hasil dari value sebelumnya), ambil value-nya
            if (field && typeof field === 'object') {
                return field.value || '';
            }
            // Jika string/number langsung
            return field || '';
        };

        const handleSaveRegist = async (updatedData,data) => {
            if (!updatedData || !data) {
                console.error("Missing data to update.");
                return;
            }
            setLoadingSave(true);

            const newRegistration = {
                full_name: currentData?.full_name,
                no_medical_record: updatedData?.no_medical_record,
                no_appointment: updatedData?.no_appointment,
                treatment: getSelectValue(updatedData?.treatment),
                kd_employee: '',
                doctor: getSelectValue(updatedData?.doctor_id),
                room_id: updatedData?.room_id,
                notes: currentData?.notes,
                created_by: user.user.id,
                klinik_id: user.user.klinik_id,
                status: 'Receipt',
                created_at: new Date().toISOString().split('T')[0],
            };

            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/registration/create`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        },
                        body: JSON.stringify(newRegistration)
                    }
                );

                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    setNotifType('danger');
                    setNotifMessage(errorData.message || 'Gagal membuat data registrasi!');
                    setShowNotif(true);
                    setShowModalRegist(false); 
                    setLoadingSave(false);
                    return;
                }

                const updateStatus = await fetch(`${API_BASE_URL}/auth/appointment/${updatedData.id}`, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    },
                    body: JSON.stringify({
                        no_medical_record: updatedData?.no_medical_record,
                        status: 'Confirmed' 
                    })
                });

                if (!updateStatus.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    setNotifType('danger');
                    setNotifMessage(errorData.message || 'Gagal membuat data registrasi!');
                    setShowNotif(true);
                    setShowModalRegist(false); 
                    setLoadingSave(false);
                    return;
                }

                fetchData();
                setNotifType('success');
                setNotifMessage('Registrasi dan konfirmasi berhasil!');
            } catch (error) {
                setNotifType('danger');
                setNotifMessage('Terjadi kesalahan koneksi!');
                setShowNotif(true);
                setShowRegistModal(false);
                setShowModalRegist(false); 
                setLoadingSave(false);
            } finally {
                setShowNotif(true);
                setShowRegistModal(false);
                setShowModalRegist(false); 
                setLoadingSave(false);
            }
        }

        const handleConfirmModal = (item) => {
            setSelectedUser(item);
            setShowConfirmModal(true);
        }

        const handleCancelModal = (item) => {
            setSelectedUser(item);
            setShowCancelModal(true);
        }

        const handleRegistModal = (item) => {
            setSelectedUser(item);
            setShowRegistModal(true);
        }

        const formatDateYMD = (date) => {
            if (!date) return '';
            const d = new Date(date);
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        };

        const getBadgeClass = (status) => {
            switch (status) {
                case 'Cancel':
                case 'Canceled':
                    return 'badge badge-light-danger';
                case 'Pending':
                    return 'badge badge-light-warning';
                case 'Confirmed':
                    return 'badge badge-light-success';
                default:
                    return 'badge badge-light-secondary';
            }
        };
        
        return (
            <>
                <div className="table-responsive">
                    <table className="table align-middle table-row-dashed fs-6 gy-5">
                        <thead>
                            <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                <th className="min-w-100px">ACTIONS</th>
                                <th className="min-w-100px">PATIENT</th>
                                <th className="min-w-75px">DATE</th>
                                <th className="min-w-75px">TIME</th>
                                <th className="min-w-100px">DOCTOR/THERAPIS</th>
                                <th className="min-w-100px">NO.MR/TELP</th>
                                <th className="min-w-75px">CREATED BY</th>
                                <th className="min-w-75px">ARRIVAL STATUS</th>
                                <th className="min-w-100px">TREATMENT</th>
                            </tr>
                        </thead>
                        <tbody className="fw-semibold text-gray-600">
                            {filteredData.map((item, index) => (
                                <tr key={index}>
                                    <td ref={(el) => (dropdownRef.current[index] = el)}>
                                        <SButton
                                         className={"btn btn-light-secondary"}
                                         children={actions()}
                                         action={() => toggleAction(index)}
                                        />

                                        {activeIndex === index && (
                                            <div  
                                                id={`dropdown-${index}`}
                                                className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-200px py-4"
                                                style={{
                                                    display: "block",
                                                    position: "absolute",
                                                    zIndex: 1000,
                                                }}
                                            >   
                                                <div className="menu-item px-3">
                                                    <SButton
                                                        className={'menu-link px-3 w-100'}
                                                        variant={'transparent'}
                                                        size={'sm'}
                                                        action={() => navigate('/package-history',{
                                                            state: {
                                                                ...item,
                                                                from: [
                                                                    {label: 'Appointment', path: '/appointment'},
                                                                ]
                                                            }
                                                        })}    
                                                    >
                                                        Package History
                                                    </SButton>
                                                </div>
                                                {item.status !== "Canceled"  && (
                                                    <>
                                                        <div className="menu-item px-3">
                                                            <SButton
                                                                className={'menu-link px-3 w-100'}
                                                                variant={'transparent'}
                                                                size={'sm'}
                                                                action={() => handleRegistModal(item)}
                                                            >
                                                                Registration
                                                            </SButton>
                                                        </div>
                                                        <div className="menu-item px-3">
                                                            <SButton
                                                                className={'menu-link px-3 w-100'}
                                                                variant={'transparent'}
                                                                size={'sm'}
                                                                action={() => handleEditModal(item)}
                                                            >
                                                                Edit
                                                            </SButton>
                                                        </div>
                                                        {item.status !== "Confirmed" && (
                                                        <>
                                                            <div className="menu-item px-3">
                                                                <SButton
                                                                    className={'menu-link px-3 w-100'}
                                                                    variant={'transparent'}
                                                                    size={'sm'}
                                                                    action={() => handleConfirmModal(item)}
                                                                >
                                                                    Confirm
                                                                </SButton>
                                                            </div>
                                                            <div className="menu-item px-3">
                                                                <SButton
                                                                    className={'menu-link px-3 w-100'}
                                                                    variant={'transparent'}
                                                                    size={'sm'}
                                                                    action={() => handleCancelModal(item)}
                                                                >
                                                                    Cancel
                                                                </SButton>
                                                            </div>
                                                        </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        )}
                                    </td>
                                    <td>{item.full_name}</td>
                                    <td>{formatDate(item.appointment_date)}</td>
                                    <td>{formatTime(item.appointment_time)}</td>
                                    <td>{item.therapist_name}</td>
                                    <td className='text-end'>{item.no_medical_record}</td>
                                    <td>{item.created_by}</td>
                                    <td>
                                        <div className={getBadgeClass(item.status)}>
                                            {item.status}
                                        </div>   
                                    </td>
                                    <td>{item.treatment_name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <PaginationCustom
                        data={arr || []}
                        page={10}
                        current={1}
                        onPaginate={handlePagination}
                    />
                    { showNotif && (
                        <ShowAlert 
                            title={notifType === 'success' ? 'Ok, got it!' : 'Oops!'}
                            message={notifMessage}
                            pic={notifType === 'success' ? Ceklis : undefined}
                            show={showNotif} 
                            setShow={setShowNotif}
                            onClose={handleCloseConfirm}
                            swal={notifType === 'success' ? 'swal2-success' : 'swal2-danger'}
                        />
                    )}
                    {showModal && currentData && (
                        <ModalForm
                            show={showModal}
                            handleClose={handleCloseModal}
                            data={currentData}
                            formDatas={fields}
                            title={'Edit Appointment'}
                            handleSave={handleSaveModal}
                        />
                    )}
                    {showModalRegist && currentData && (
                        <ModalForm
                            show={showModalRegist}
                            handleClose={handleCloseModalRegist}
                            data={currentData}
                            formDatas={fields}
                            title={'Registration Appointment'}
                            handleSave={handleSaveRegist}
                        />
                    )}
                    {showConfirmModal && (
                        <ConfirmModal 
                            title={'No, Return'}
                            title2={'Yes, Confirm'}
                            message={`Are you sure, ${selectedUser?.full_name} will be confirmed?`}
                            show={showConfirmModal}
                            setShow={setShowConfirmModal}
                            pic={Young}
                            handleSave={handleSubmitConfirm}
                            selected={selectedUser}
                        />
                    )}
                    {showCancelModal && (
                        <ConfirmModal 
                            title={'No, Return'}
                            title2={'Yes, Cancel It!'}
                            message={`Are you sure, ${selectedUser?.full_name} will cancel her Appointment?`}
                            show={showCancelModal}
                            setShow={setShowCancelModal}
                            pic={Man}
                            handleSave={handleCancelConfirm}
                            selected={selectedUser}
                        />
                    )}
                    {showRegistModal && (
                        <ConfirmModal 
                            title={'No, Return'}
                            title2={'Yes, Regist!'}
                            message={`Are you sure, ${selectedUser?.full_name} will Registration her Appointment?`}
                            show={showRegistModal}
                            setShow={setShowRegistModal}
                            pic={Young}
                            handleSave={handleRegistConfirm}
                            selected={selectedUser}
                        />
                    )}
                   
                </div>
            </>
        )
    }

    return (
        <>
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
                <Breadcrumb title={'Home'} header={'Appointment'}/>
                <div className='app-container container-xxl d-flex'>
                    <div className='app-main flex-column flex-row-fluid' id="kt_app_main">
                        <div className='d-flex flex-column flex-column-fluid'>
                            <div className='app-content'>
                            {isLoading ? (
                                <CardBasic
                                    className={'card-flush'}
                                    className3={'align-items-center py-5 gap-2 gap-md-5'}
                                    header={CardTitle()}
                                    className2={'pt-0'}
                                >
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
                                        <div className="spinner-border text-primary" role="status"></div>
                                    </div>
                                </CardBasic> 
                               
                            ) : (
                                <CardBasic
                                    className={'card-flush'}
                                    className3={'align-items-center py-5 gap-2 gap-md-5'}
                                    header={CardTitle()}
                                    className2={'pt-0'}
                                >
                                    <ListBody 
                                        arr={newData} 
                                        fetchData={fetchData}
                                        therapisOpt={therapisOpt}
                                    />
                                </CardBasic> 
                            ) }
                            </div>
                        </div>
                        <div className='app-footer d-flex flex-column flex-md-row flex-center flex-md-stack pb-3'>
                            <div className='text-dark order-2 order-md-1'>
                                <span className='text-muted fw-semibold me-1'>2025&copy;</span>
                            </div>
                            <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
                                <li className='menu-item'><span className='menu-link px-2'>About</span></li>
                                <li className='menu-item'><span className='menu-link px-2'>Support</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {loadingSave && (
                <div
                    style={{
                    position: 'fixed',
                    zIndex: 2000,
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(255,255,255,0.6)',
                    backdropFilter: 'blur(2px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                    }}
                >
                    <div className="spinner-border text-primary" role="status" style={{ width: 60, height: 60 }}></div>
                </div>
            )}
        </>
    )
}

export default Appointment
